import { useTranslation } from 'react-i18next'

const UnderReviewTile = () => {
  const { t } = useTranslation()

  return (
    <main className="general-message">
      <div>
        <h4 className="subtitle">{t('common.AnalysisInProgress')}</h4>
        <h3>{t('common.hasBeenSubmitted')}</h3>
      </div>
    </main>
  )
}

export default UnderReviewTile
